import React, { useEffect, useState } from "react";
import { Col, Form, Row, Spinner, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import Select from 'react-select';
import { IoMdClose } from "react-icons/io";
import { authHeader } from "../../../services/auth-header";
import { BASE_URL } from "../../../services/Api";

const SrMIView = () => {
    const { id } = useParams(); // Assuming you're passing the sales ID as a route parameter
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [grandtotalinr, setGrandTotalInr] = useState(0);
    const [grandtotalcurrency, setGrandTotalCurrency] = useState(0);
    const [exportpreperationchargescurrency, setexportpreperationchargesCurrency] = useState(0);
    const [exchangeRate, setExchangeRate] = useState(0);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [rows, setRows] = useState([]);
    const [productOptions, setProductOptions] = useState([]);
    const unitOptions = [
        { value: "", label: "Select UOM" },
        { value: "bot", label: "Bot" },
        { value: "ctn", label: "Ctn" },
        { value: "days", label: "Days" },
        { value: "ft", label: "Ft" },
        { value: "hrs", label: "Hrs" },
        { value: "kg", label: "Kg" },
        { value: "ltr", label: "Ltr" },
        { value: "mtr", label: "Mtr" },
        { value: "nos", label: "Nos" },
        { value: "pil", label: "Pil" },
        { value: "pkt", label: "Pkt" },
        { value: "set", label: "Set" },
        { value: "pcs", label: "Pcs" }
    ];

    const [currencyOptions] = useState([
        { value: "", label: "Select Currency" },
        { value: "$ (USD)", label: "USD" },
        { value: "€ (EUR)", label: "EUR" },
        { value: "¥ (JPY)", label: "JPY" },
        { value: "£ (GBP)", label: "GBP" },
        { value: "₹ (INR)", label: "INR" },


    ]);
    const [selectedCurrency, setSelectedCurrency] = useState(null); // Default to first currency
    // ITEMS 
    const [customer, setCustomer] = useState(null);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [customerDetails, setCustomerDetails] = useState({
        contactperson: '',
        contactno: '',
        email: '',
    });
    const [customerAddresses, setCustomerAddresses] = useState([]);
    const [customerAddress, setCustomerAddress] = useState(null);
    const [shipTo, setShipTo] = useState(null);
    const [billTo, setBillTo] = useState(null);
    const [branch, setBranch] = useState(null);
    const [branchOptions, setBranchOptions] = useState([]);
    const [warehouse, setWarehouse] = useState(null);
    const [warehouseOptions, setWarehouseOptions] = useState([]);
    ///////
    const [invoiceno, setinvoiceno] = useState('');
    const [invoicedate, setinvoicedate] = useState("");
    const [packinglistno, setpackinglistno] = useState("");
    const [dispatchthrough, setdispatchthrough] = useState("");
    const [packinglistdate, setpackinglistdate] = useState("");
    const [portofdischarge, setportofdischarge] = useState("");
    const [reference, setreference] = useState("");
    const [buyerorderno, setbuyerorderno] = useState("");
    const [buyerorderdate, setbuyerorderdate] = useState("");
    const [countryofdestination, setcountryofdestination] = useState('');
    const [termsofdelivery, settermsofdelivery] = useState('');
    const [incoterm, setincoterm] = useState('');
    const [countryoforigin, setcountryoforigin] = useState('india');
    const [airsea, setairsea] = useState('');
    const [portofloading, setportofloading] = useState('');
    const [status, setstatus] = useState('');
    const [salesreturnno, setsalesreturnno] = useState('');
    const [salesreturndate, setsalesreturndate] = useState('');




    useEffect(() => {
        getPumpProductData();
        getBranchData();
        getWarehouseData();
        getCustomerData();
        if (id) {
            getSalesDetails(id); // Fetch sales details if ID is present
        }
    }, [id]);

    const getSalesDetails = async (id) => {
        try {
            const response = await axios.get(`${BASE_URL}salesReturn/findById/${id}`, {
                headers: authHeader(),
            });
            const salesData = response.data;
            console.log('salesData by id', salesData);
            if (salesData.salesReturnItems.length > 0) {
                setExchangeRate(salesData.salesReturnItems[0].exchangerate);
                setSelectedCurrency(salesData.salesReturnItems[0].currency || currencyOptions[0].value);
            }

            // Set the exchange rate from the first sales item
            if (salesData.salesReturnItems.length > 0) {
                setExchangeRate(salesData.salesReturnItems[0].exchangerate); // Set from the first item
            }

            // // Set the exchange rate from the first sales item
            // if (salesData.salesReturnItems.length > 0) {
            //     setExchangeRate(salesData.salesReturnItems[0].exchangerate); // Set from the first item
            // }

            setGrandTotalInr(salesData.grandtotalinr);
            setGrandTotalCurrency(salesData.grandtotalcurrency);
            setexportpreperationchargesCurrency(salesData.exportpreperationchargescurrency);

            const salesReturnItems = salesData.salesReturnItems.map(item => ({
                product: { id: item.product.id, name: item.product.description },
                quantity: item.quantity,
                exchangerate: item.exchangerate,
                unitrateinr: item.unitrateinr,
                totalinr: item.totalinr,
                totalcurrency: item.totalcurrency,
                unitratecurrency: item.unitratecurrency,
                itemcode: item.itemcode,
                hsnsacno: item.hsnsacno,
                uom: item.uom,
                productremarks: item.productremarks,
                currency: item.currency,
                serialnumber: item.serialnumber,
                modelnumber: item.modelnumber,
                tagnumber: item.tagnumber,
                moc: item.moc,
                partno: item.partno,
            }));
            setRows(salesReturnItems);

            // Set the form fields with the fetched sales data
            setCustomer({ value: salesData.customer.id, label: salesData.customer.companyname });
            setCustomerDetails({
                contactperson: salesData.contactperson,
                contactno: salesData.contactno,
                email: salesData.email,
            });
            setCustomerAddress({ value: salesData.customeraddress.id, label: salesData.customeraddress.customeraddress });
            setShipTo({ value: salesData.shipto.id, label: salesData.shipto.customeraddress });
            setBillTo({ value: salesData.billto.id, label: salesData.billto.customeraddress });
            setBranch({ value: salesData.branch.id, label: salesData.branch.branchname });
            setWarehouse({ value: salesData.warehouse.id, label: salesData.warehouse.warehousename });

            getCustomerAddresses(salesData.customer.id); // Fetch customer addresses

            setinvoiceno(salesData.invoiceno);
            setinvoicedate(salesData.invoicedate);
            setpackinglistno(salesData.packinglistno);
            setdispatchthrough(salesData.dispatchthrough);
            setpackinglistdate(salesData.packinglistdate);
            setportofdischarge(salesData.portofdischarge);
            setreference(salesData.reference);
            setbuyerorderno(salesData.buyerorderno);
            setbuyerorderdate(salesData.buyerorderdate);
            setcountryofdestination(salesData.countryofdestination);
            settermsofdelivery(salesData.termsofdelivery);
            setcountryoforigin(salesData.cunsetcountryoforigin);
            setairsea(salesData.airsea);
            setportofloading(salesData.portofloading);
            setstatus(salesData.status)
            setincoterm(salesData.incoterm)
            setsalesreturnno(salesData.salesreturnno)
            setsalesreturndate(salesData.salesreturndate)
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch sales details. Please try again.',
            });
        }
    };


    const getCustomerData = async () => {
        try {
            const response = await axios.get(`${BASE_URL}customer/findAllCustomer`, {
                headers: authHeader(),
            });
            setCustomerOptions(response.data.map(customer => ({
                value: customer.id,
                label: customer.companyname
            })));
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch customer. Please try again.',
            });
        }
    };


    const getCustomerAddresses = async (customerId) => {
        try {
            const response = await axios.get(`${BASE_URL}customerMultipleAddress/getAddress/${customerId}`, {
                headers: authHeader(),
            });
            setCustomerAddresses(response.data.map(address => ({
                value: address.id,
                label: address.customeraddress,
                countryname: address.countryname
            })));
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch customer addresses. Please try again.',
            });
        }
    };

    const handleCustomerChange = (selectedOption) => {
        setCustomer(selectedOption);
        if (selectedOption) {
            getcustomerDetails(selectedOption.value);
            // Fetch customer details when customer is selected
            setCustomerDetails({
                contactperson: "", // Clear or set appropriate value
                contactno: '',
                email: ""
            });
            setCustomerAddresses([]);
            setCustomerAddress(null);
            setShipTo(null);
            setBillTo(null);
            getCustomerAddresses(selectedOption.value); // Fetch addresses for selected customer
        }
    };

    const getcustomerDetails = async (id) => {
        try {
            const response = await axios.get(`${BASE_URL}customer/findById/${id}`, {
                headers: authHeader(),
            });
            setCustomerDetails({
                contactperson: response.data.contactperson,
                contactno: response.data.contactno,
                email: response.data.email,
            });
            getCustomerAddresses(id);
            setincoterm(response.data.incoterms)
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch customer details. Please try again.',
            });
        }
    };

    // const handleShipToChange = (selectedOption) => {
    //     setShipTo(selectedOption);
    // };
    const handleShipToChange = (selectedOption) => {
        setShipTo(selectedOption);
        if (selectedOption) {
            const selectedAddress = customerAddresses.find(address => address.value === selectedOption.value);
            if (selectedAddress && selectedAddress.countryname) {
                setcountryofdestination(selectedAddress.countryname);
            } else {
                setcountryofdestination('');
            }
        }
    };

    const handleBillToChange = (selectedOption) => {
        setBillTo(selectedOption);
    };

    const getWarehouseData = async () => {
        try {
            const response = await axios.get(`${BASE_URL}warehouse/findAllWarehouse`, {
                headers: authHeader(),
            });
            setWarehouseOptions(response.data.map(warehouse => ({ value: warehouse.id, label: warehouse.warehousename })));
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch Warehouse. Please try again.',
            });
        }
    };

    const getBranchData = async () => {
        try {
            const response = await axios.get(`${BASE_URL}branch/findAllBranch`, {
                headers: authHeader(),
            });
            setBranchOptions(response.data.map(branch => ({ value: branch.id, label: branch.branchname })));
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch branch. Please try again.',
            });
        }
    };

    // ITEMS 

    const getPumpProductData = async () => {
        try {
            const response = await axios.get(`${BASE_URL}product/getAllInternationalMfgProduct`, {
                headers: authHeader(),
            });
            setProductOptions(response.data.map(product => ({
                value: product.id,
                label: product.description,
                exchangerate: product.exchangerate,
                itemcode: product.itemcode,
                hsnsacno: product.hsnsacno,
                serialnumber: product.serialnumber,
                modelnumber: product.modelnumber,
                tagnumber: product.tagnumber,
                moc: product.moc,
                partno: product.partno,
                uom: product.unitofmeasurement || unitOptions[0].value,
            })));
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch products. Please try again.',
            });
        }
    };

    const handleProductChange = (selectedOption) => {
        setSelectedProduct(selectedOption);
        const selectedProductData = productOptions.find(product => product.value === selectedOption.value);

        if (selectedProductData) {
            const newRow = {
                product: { id: selectedOption.value, name: selectedOption.label },
                quantity: '',
                exchangerate: selectedProductData.exchangerate || '',
                unitrateinr: selectedProductData.unitrateinr || '',
                totalinr: 0,
                totalcurrency: 0,
                unitratecurrency: '',
                hsnsacno: selectedProductData.hsnsacno,
                itemcode: selectedProductData.itemcode,
                serialnumber: selectedProductData.serialnumber,
                modelnumber: selectedProductData.modelnumber,
                tagnumber: selectedProductData.tagnumber,
                moc: selectedProductData.moc,
                partno: selectedProductData.partno,
                uom: selectedProductData.uom || unitOptions[0].value,
                productremarks: "",
                // currency: currencyOptions[0].value,
                currency: selectedCurrency || currencyOptions[0].value,
            };
            setRows([...rows, newRow]);
        }
    };

    const handleRowChange = (index, key, value) => {
        const updatedRows = [...rows];
        updatedRows[index][key] = value;

        const unitratecurrency = parseFloat(updatedRows[index].unitratecurrency) || 0;
        const quantity = parseFloat(updatedRows[index].quantity) || 0;

        updatedRows[index].unitrateinr = unitratecurrency * (updatedRows[index].exchangerate || exchangeRate);
        updatedRows[index].totalinr = updatedRows[index].unitrateinr * quantity;
        updatedRows[index].totalcurrency = unitratecurrency * quantity;

        setRows(updatedRows);
    };

    const removeRow = (index) => {
        const updatedRows = [...rows];
        updatedRows.splice(index, 1);
        setRows(updatedRows);
    };

    useEffect(() => {
        const totalinr = rows.reduce((total, row) => total + (row.totalinr || 0), 0);
        const totalInCurrency = rows.reduce((total, row) => total + (row.totalcurrency || 0), 0);
        setGrandTotalInr(totalinr);
        setGrandTotalCurrency(totalInCurrency);
    }, [rows]);

    const handleExchangeRateChange = (value) => {
        setExchangeRate(value);
        const updatedRows = rows.map(row => ({
            ...row,
            exchangerate: value,
            unitrateinr: (parseFloat(row.unitratecurrency) || 0) * value,
            totalinr: (parseFloat(row.unitratecurrency) || 0) * value * (parseFloat(row.quantity) || 0),
        }));
        setRows(updatedRows);
    };

    const exportpreperationcharges = exportpreperationchargescurrency * exchangeRate;

    const handleSubmit = async () => {
        setIsLoading(true);

        const salesReturnItems = rows.map(row => ({
            product: { id: row.product.id },
            exchangerate: row.exchangerate || exchangeRate, // Send the correct exchangerate
            quantity: row.quantity || 0,
            unitrateinr: row.unitrateinr || 0,
            totalinr: row.totalinr || 0,
            totalcurrency: row.totalcurrency || 0,
            unitratecurrency: row.unitratecurrency || 0,
            itemcode: row.itemcode || '',
            hsnsacno: row.hsnsacno || '',
            serialnumber: row.serialnumber || '',
            modelnumber: row.modelnumber || '',
            tagnumber: row.tagnumber || '',
            moc: row.moc || '',
            partno: row.moc || '',
            uom: row.uom || '',
            productremarks: row.productremarks || '',
            currency: selectedCurrency,
        }));

        const exportpreperationcharges = exportpreperationchargescurrency * exchangeRate; // Calculate shipping charges in INR
        const netTotalInr = grandtotalinr + exportpreperationcharges; // Net Total (INR)
        const netTotalCurrency = grandtotalcurrency + exportpreperationchargescurrency; // Net Total In (Currency)

        const salesData = {
            salesReturnItems,
            salesreturntype: 'Manufacturing',
            salesreturncategory: 'International',
            grandtotalinr: netTotalInr, // Net Total (INR)
            exportpreperationcharges, // Shipping Charges (INR)
            grandtotalcurrency: netTotalCurrency, // Net Total In (Currency)
            exportpreperationchargescurrency, // Shipping Charges (Currency)
            netamount: grandtotalinr,
            netamountcurrency: grandtotalcurrency,

            // ITEMS 
            customer: { id: customer.value },
            contactno: customerDetails.contactno,
            contactperson: customerDetails.contactperson,
            email: customerDetails.email,
            customeraddress: { id: customerAddress?.value },
            shipto: { id: shipTo?.value },
            billto: { id: billTo?.value },
            branch: branch ? { id: branch.value } : null,
            warehouse: warehouse ? { id: warehouse.value } : null,
            ///
            invoiceno,
            packinglistno,
            dispatchthrough,
            packinglistdate,
            portofdischarge,
            invoicedate,
            reference,
            buyerorderno,
            buyerorderdate,
            countryofdestination,
            termsofdelivery,
            incoterm,
            countryoforigin,
            airsea,
            portofdischarge,
            portofloading,
            status,
            salesreturnno,
            salesreturndate,
        };
        console.log('salesData', salesData);

        try {
            const response = await axios.put(`${BASE_URL}salesReturn/update/${id}`, salesData, {
                headers: authHeader()
            });
            console.log('put api', response.data);
            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Sales Return Updated successfully!',
            });
            navigate("/srindex/1");
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response.data || 'Failed to update sales return. Please try again.',
            });
        } finally {
            setIsLoading(false);
        }
    }


    return (
        <div className="container">
            <br />
            <Form>
                <Row>
                    <Col md="6">
                        <Form.Group controlId="contactperson">
                            <Form.Label>Sales Return No</Form.Label>
                            <Form.Control type="text" disabled value={salesreturnno} disabled />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group controlId="invoicedate">
                            <Form.Label>Sales Return Date</Form.Label>
                            <Form.Control
                                type="date" disabled
                                value={salesreturndate}
                                onChange={(e) => setsalesreturndate(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group controlId="contactperson">
                            <Form.Label>Invoice No.</Form.Label>
                            <Form.Control type="text" disabled value={invoiceno}
                                onChange={(e) => setinvoiceno(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group controlId="invoicedate">
                            <Form.Label>Invoice Date</Form.Label>
                            <Form.Control
                                type="date" disabled
                                value={invoicedate}
                                onChange={(e) => setinvoicedate(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group>
                            <Form.Label>Branch</Form.Label>
                            <Select
                                value={branch}
                                onChange={setBranch}
                                isDisabled
                                options={branchOptions}
                                placeholder="Select branch"
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group>
                            <Form.Label>Warehouse</Form.Label>
                            <Select
                                value={warehouse}
                                onChange={setWarehouse}
                                isDisabled
                                options={warehouseOptions}
                                placeholder="Select Warehouse"
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group controlId="customer">
                            <Form.Label>Customer:</Form.Label>
                            <Select
                                value={customer}
                                onChange={handleCustomerChange}
                                isDisabled
                                options={customerOptions}
                                placeholder="Select customer"
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group controlId="contactperson">
                            <Form.Label>Contact Person</Form.Label>
                            <Form.Control type="text" disabled value={customerDetails.contactperson} disabled />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group controlId="contactno">
                            <Form.Label>Contact Number:</Form.Label>
                            <Form.Control type="text" disabled value={customerDetails.contactno} disabled />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group controlId="email">
                            <Form.Label>Customer Email:</Form.Label>
                            <Form.Control type="text" disabled value={customerDetails.email} disabled />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group controlId="address">
                            <Form.Label>Customer Address:</Form.Label>
                            <Select
                                isDisabled
                                options={customerAddresses}
                                placeholder="Select Address"
                                onChange={setCustomerAddress}
                                value={customerAddress}
                                isClearable
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group controlId="packinglistno">
                            <Form.Label>Packing List No.</Form.Label>
                            <Form.Control
                                type="text" disabled
                                value={packinglistno}
                                onChange={(e) => setpackinglistno(e.target.value)}
                                disabled
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group controlId="packinglistdate">
                            <Form.Label>Packing List Date</Form.Label>
                            <Form.Control
                                type="date" disabled
                                value={packinglistdate}
                                onChange={(e) => setpackinglistdate(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group controlId="date">
                            <Form.Label>Dispatch Through</Form.Label>
                            <Form.Control
                                type="text" disabled
                                value={dispatchthrough}
                                onChange={(e) => setdispatchthrough(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group controlId="airsea">
                            <Form.Label>By Air/Sea</Form.Label>
                            <Form.Control
                                type="text" disabled
                                value={airsea}
                                onChange={(e) => setairsea(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group controlId="portofloading">
                            <Form.Label>Port of Loading</Form.Label>
                            <Form.Control
                                type="text" disabled
                                value={portofloading}
                                onChange={(e) => setportofloading(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group controlId="portofdischarge">
                            <Form.Label>Port of Discharge</Form.Label>
                            <Form.Control
                                type="text" disabled
                                value={portofdischarge}
                                onChange={(e) => setportofdischarge(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group controlId="termsofdelivery">
                            <Form.Label>Terms of Delivery</Form.Label>
                            <Form.Control
                                type="text" disabled
                                value={termsofdelivery}
                                onChange={(e) => settermsofdelivery(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group controlId="reference">
                            <Form.Label>Reference</Form.Label>
                            <Form.Control
                                type="text" disabled
                                value={reference}
                                onChange={(e) => setreference(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group controlId="buyerorderno">
                            <Form.Label>Buyer Order No.</Form.Label>
                            <Form.Control
                                type="text" disabled
                                value={buyerorderno}
                                onChange={(e) => setbuyerorderno(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group controlId="buyerorderdate">
                            <Form.Label>Buyer Order Date</Form.Label>
                            <Form.Control
                                type="date" disabled
                                value={buyerorderdate}
                                onChange={(e) => setbuyerorderdate(e.target.value)}
                            />
                        </Form.Group>
                    </Col>

                    <Col md="6">
                        <Form.Group controlId="portofdischarge">
                            <Form.Label>Incoterm</Form.Label>
                            <Form.Control
                                type="text" disabled
                                value={incoterm}
                                onChange={(e) => setincoterm(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    {/* New Bill To Field */}
                    <Col md="6">
                        <Form.Group controlId="billTo">
                            <Form.Label>Bill To:</Form.Label>
                            <Select
                                isDisabled
                                options={customerAddresses}
                                placeholder="Select Bill To Address"
                                onChange={handleBillToChange}
                                value={billTo}
                                isClearable
                            />
                        </Form.Group>
                    </Col>
                    {/* New Ship To Field */}
                    <Col md="6">
                        <Form.Group controlId="shipTo">
                            <Form.Label>Ship To:</Form.Label>
                            <Select
                                isDisabled
                                options={customerAddresses}
                                placeholder="Select Ship To Address"
                                onChange={handleShipToChange}
                                value={shipTo}
                                isClearable
                            />
                        </Form.Group>
                    </Col>

                    <Col md="6">
                        <Form.Group controlId="countryofdestination">
                            <Form.Label>Country of Destination</Form.Label>
                            <Form.Control
                                type="text" disabled
                                value={countryofdestination}
                                onChange={(e) => setcountryofdestination(e.target.value)}
                                disabled
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group controlId="countryoforigin">
                            <Form.Label>Country of Origin</Form.Label>
                            <Form.Control
                                type="text" disabled
                                value={countryoforigin}
                                onChange={(e) => setcountryoforigin(e.target.value)}
                                disabled
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group controlId="contactperson">
                            <Form.Label>Status</Form.Label>
                            <Form.Control type="text" disabled value={status} disabled />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group controlId="billTo">
                            <Form.Label>Currency</Form.Label>
                            <Select
                                value={currencyOptions.find(option => option.value === selectedCurrency)} // Display fetched currency
                                onChange={(selectedOption) => {
                                    setSelectedCurrency(selectedOption.value);
                                    // Update rows if needed
                                    const updatedRows = rows.map(row => ({
                                        ...row,
                                        currency: selectedOption.value // Update each row with the selected currency
                                    }));
                                    setRows(updatedRows);
                                }}
                                isDisabled
                                options={currencyOptions}
                                placeholder="Select Currency"
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group>
                            <Form.Label>Exchange Rate (INR/Currency)</Form.Label>
                            <Form.Control
                                type="number" disabled
                                value={exchangeRate || ''}
                                onChange={(e) => handleExchangeRateChange(parseFloat(e.target.value) || 0)}
                                placeholder="Enter Exchange Rate"
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <hr />
                <br />
                {/* <label>Select a Product:</label>
                <Select
                    value={selectedProduct}
                    onChange={handleProductChange}
                    isDisabled
                    options={productOptions}
                    placeholder="Select Product"
                /> */}
                <br />
                <div className="table-responsive">

                    <Table className="table thrtable">
                        <thead>
                            <tr>
                                <th>Product Description</th>
                                <th>Product Code</th>
                                <th>HSN Code</th>
                                <th>Serial No.</th>
                                <th>Model No.</th>
                                <th>Tag No.</th>
                                <th>Part No.</th>
                                <th>MOC</th>
                                <th>unit of measurement</th>
                                <th>Currency</th>
                                <th>Quantity</th>
                                <th>Unit Rate (Currency)</th>
                                <th>Total (Currency)</th>
                                <th>Exchange Rate/Currency (INR)</th>
                                <th>Unit Price (INR)</th>
                                <th>Total (INR)</th>
                                {/* <th>Action</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((row, index) => (
                                <tr key={index}>
                                    <td>{row.product.name}
                                        <Form.Control as="textarea" rows={2}
                                            className="remarks"
                                            type="text" disabled
                                            value={row.productremarks}
                                            onChange={(e) => handleRowChange(index, 'productremarks', e.target.value)}
                                            placeholder=" Enter item remarks"
                                        />
                                    </td>
                                    <td>{row.itemcode}</td>
                                    <td>{row.hsnsacno}</td>
                                    <td>{row.serialnumber}</td>
                                    <td>{row.modelnumber}</td>
                                    <td>{row.tagnumber}</td>
                                    <td>{row.partno}</td>
                                    <td>{row.moc}</td>
                                    <td>
                                        <Select
                                            className="uom"
                                            value={unitOptions.find(option => option.value === row.uom)}
                                            onChange={(selectedOption) => handleRowChange(index, 'uom', selectedOption.value)}
                                            isDisabled
                                            options={unitOptions}
                                            placeholder="Select Unit"
                                        />
                                    </td>
                                    <td>
                                        <Select
                                            className="uom"
                                            value={currencyOptions.find(option => option.value === row.currency)} // Show row's currency
                                            isDisabled
                                            options={[currencyOptions.find(option => option.value === row.currency)]} // Show only current row currency
                                            placeholder="Select Currency"
                                            isDisabled // Disable the Select
                                        />
                                    </td>
                                    <td>
                                        <Form.Control
                                            min="0"
                                            className="uom"
                                            type="number" disabled
                                            value={row.quantity || ''}
                                            onChange={(e) => handleRowChange(index, 'quantity', e.target.value)}
                                        />
                                    </td>

                                    <td>
                                        <Form.Control
                                            className="uom"
                                            min="0"
                                            type="number" disabled
                                            value={row.unitratecurrency || ''}
                                            onChange={(e) => handleRowChange(index, 'unitratecurrency', e.target.value)}
                                        />
                                    </td>
                                    <td>{(row.totalcurrency || 0).toFixed(2)}</td>
                                    <td>
                                        <Form.Control
                                            min="0"
                                            type="number" disabled
                                            value={row.exchangerate || exchangeRate} // Display current exchange rate
                                            onChange={(e) => handleRowChange(index, 'exchangerate', e.target.value)}
                                            className="uom"
                                            disabled
                                        />
                                    </td>
                                    <td>
                                        <Form.Control
                                            min="0"
                                            type="number" disabled
                                            value={(row.unitrateinr || 0).toFixed(2)}
                                            style={{ width: "160px" }}
                                            disabled
                                        />
                                    </td>
                                    <td>{(row.totalinr || 0).toFixed(2)}</td>
                                    {/* <td>
                                        <button type="button" onClick={() => removeRow(index)}>
                                            <IoMdClose />
                                        </button>
                                    </td> */}
                                </tr>
                            ))}

                            <tr>
                                <td colSpan="14"></td>
                                <td><strong>Net Total (INR):</strong></td>
                                <td>
                                    <strong>{grandtotalinr.toFixed(2)}</strong>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="14"></td>
                                <td><strong>Export Preperation Charges (INR):</strong></td>
                                <td>
                                    <strong>{exportpreperationcharges.toFixed(2)}</strong>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="14"></td>
                                <td><strong>Grand Total (INR):</strong></td>
                                <td>
                                    <strong>{(grandtotalinr + exportpreperationcharges).toFixed(2)}</strong>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="14"></td>
                                <td><strong>Net Total In (Currency):</strong></td>
                                <td>
                                    <strong>{(grandtotalcurrency).toFixed(2)}</strong>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="14"></td>
                                <td><strong>Export Preperation Charges(Currency)</strong></td>
                                <td colSpan="1">
                                    <Form.Control
                                        className="quantity"
                                        type="number" disabled
                                        value={exportpreperationchargescurrency || ''}
                                        onChange={(e) => setexportpreperationchargesCurrency(parseFloat(e.target.value) || 0)}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="14"></td>
                                <td><strong>Grand Total In (Currency):</strong></td>
                                <td>
                                    <strong>{(grandtotalcurrency + exportpreperationchargescurrency).toFixed(2)}</strong>
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
                <br />
                {/* <button className="button-70" type="button" onClick={handleSubmit} disabled={isLoading}>
                    {isLoading ? <Spinner animation="border" size="sm" /> : 'SUBMIT'}
                </button> */}
            </Form>
        </div>
    );
};

export default SrMIView;


